// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Analytics20 from './Analytics20';
import Analytics20Circle from './Analytics20Circle';
import Analytics24 from './Analytics24';
import Analytics24Circle from './Analytics24Circle';
import Analytics40 from './Analytics40';
import Analytics48 from './Analytics48';

type AnalyticsProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Analytics20,
    Analytics20Circle,
    Analytics24,
    Analytics24Circle,
    Analytics40,
    Analytics48,
};

const Analytics: FC<AnalyticsProps> = ({ variation, ...props }) => {
    const variationKey = `Analytics${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Analytics" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Analytics;
